import * as types from '@/store/mutation-types';

const state = {
  ticketUsers: {},
};

const getters = {
  ticketUsers(state) {
    return state.ticketUsers;
  },
};

const mutations = {
  [types.SET_TICKET_USER](state, { id, data }) {
    state.ticketUsers[id] = data;
  },
};

const actions = {
  setTicketUser({ commit }, payload) {
    commit(types.SET_TICKET_USER, payload);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/admin/support/tickets/vuex.js